var _circle, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommentJuni(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    fill: "#FDFBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M33.934 58.5734C47.2253 58.5734 58 47.7987 58 34.5075C58 21.2162 47.2253 10.4415 33.934 10.4415C20.6428 10.4415 9.8681 21.2162 9.8681 34.5075C9.8681 47.7987 20.6428 58.5734 33.934 58.5734Z",
    fill: "#FF8F6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M31.45 17.6454C31.45 17.6454 29.3028 4.68477 46.5174 4.42424C46.5668 4.78847 47.3441 11.2216 42.2723 15.3842C37.5865 19.2302 31.9777 17.7909 31.45 17.6454Z",
    fill: "#42CA89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M38.5123 11.7541C38.5123 11.7541 35.7844 11.8062 31.4501 17.642",
    stroke: "#006934",
    strokeWidth: 0.267595,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0014 44.6375C25.3266 44.6375 28.0222 41.9418 28.0222 38.6166C28.0222 35.2913 25.3266 32.5957 22.0014 32.5957C18.6761 32.5957 15.9805 35.2913 15.9805 38.6166C15.9805 41.9418 18.6761 44.6375 22.0014 44.6375Z",
    fill: "#FF7364",
    stroke: "#FF8F6B",
    strokeWidth: 0.35562,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8666 44.6375C49.1919 44.6375 51.8875 41.9418 51.8875 38.6166C51.8875 35.2913 49.1919 32.5957 45.8666 32.5957C42.5414 32.5957 39.8458 35.2913 39.8458 38.6166C39.8458 41.9418 42.5414 44.6375 45.8666 44.6375Z",
    fill: "#FF7364",
    stroke: "#FF8F6B",
    strokeWidth: 0.35562,
    strokeMiterlimit: 10
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2691 38.6996C31.4396 38.6996 33.1992 35.9604 33.1992 32.5814C33.1992 29.2025 31.4396 26.4633 29.2691 26.4633C27.0986 26.4633 25.3391 29.2025 25.3391 32.5814C25.3391 35.9604 27.0986 38.6996 29.2691 38.6996Z",
    fill: "#FDFBFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4143 35.4906C32.4946 35.4906 33.3704 34.1881 33.3704 32.5814C33.3704 30.9747 32.4946 29.6722 31.4143 29.6722C30.334 29.6722 29.4582 30.9747 29.4582 32.5814C29.4582 34.1881 30.334 35.4906 31.4143 35.4906Z",
    fill: "#221714"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6708 31.9496C32.8956 31.9496 33.0778 31.6795 33.0778 31.3464C33.0778 31.0132 32.8956 30.7431 32.6708 30.7431C32.4461 30.7431 32.2639 31.0132 32.2639 31.3464C32.2639 31.6795 32.4461 31.9496 32.6708 31.9496Z",
    fill: "#FDFBFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8039 38.6995C39.9744 38.6995 41.7339 35.9603 41.7339 32.5813C41.7339 29.2023 39.9744 26.4631 37.8039 26.4631C35.6334 26.4631 33.8738 29.2023 33.8738 32.5813C33.8738 35.9603 35.6334 38.6995 37.8039 38.6995Z",
    fill: "#FDFBFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9526 35.4906C41.0329 35.4906 41.9087 34.1881 41.9087 32.5814C41.9087 30.9747 41.0329 29.6722 39.9526 29.6722C38.8723 29.6722 37.9965 30.9747 37.9965 32.5814C37.9965 34.1881 38.8723 35.4906 39.9526 35.4906Z",
    fill: "#221714"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6558 31.3428C40.9594 31.3428 41.2056 31.0966 41.2056 30.7931C41.2056 30.4895 40.9594 30.2433 40.6558 30.2433C40.3523 30.2433 40.1061 30.4895 40.1061 30.7931C40.1061 31.0966 40.3523 31.3428 40.6558 31.3428Z",
    fill: "#FDFBFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9339 43.1304C35.7437 43.1304 37.3175 43.8311 38.1485 44.8628C38.3985 44.2959 38.5393 43.6691 38.5393 43.0107C38.5393 40.4686 36.476 38.4053 33.9339 38.4053C31.3917 38.4053 29.3284 40.4686 29.3284 43.0107C29.3284 43.6691 29.4693 44.2959 29.7193 44.8628C30.5502 43.8276 32.1241 43.1304 33.9339 43.1304Z",
    fill: "#221714"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.934 47.6195C35.8178 47.6195 37.4374 46.4857 38.1487 44.8661C37.3177 43.8309 35.7438 43.1337 33.934 43.1337C32.1243 43.1337 30.5504 43.8344 29.7194 44.8661C30.4307 46.4857 32.0503 47.6195 33.934 47.6195Z",
    fill: "#E17766"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5609 39.0705C32.0785 39.8275 32.9482 40.3275 33.9341 40.3275C34.9199 40.3275 35.7896 39.831 36.3072 39.0705C35.6136 38.6515 34.8037 38.4086 33.9341 38.4086C33.0644 38.4086 32.2545 38.655 31.5609 39.0705Z",
    fill: "#FDFBFB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentJuni);
export default __webpack_public_path__ + "static/media/comment-juni.e53346977cf676116941d6d4a10cc702.svg";
export { ForwardRef as ReactComponent };